import axios from 'axios'
import config from '../../config'
import { handleCommonResponseErrors } from '../handle-errors'

// create axios instance
const unauthenticated = axios.create({
  baseURL: `${config.apiDomain}/api`
})

const preRequest = (config) => {
  config.headers = {
    'X-Requested-With': 'XMLHttpRequest'
  }

  return config
}
unauthenticated.interceptors.response.use(preRequest, (err) => {
  handleCommonResponseErrors(err)

  return Promise.reject(err)
})

export default unauthenticated



// WEBPACK FOOTER //
// ./src/api/http-clients/unauthenticated.js